<template>
    <VuePassword v-model="password"
                 :id="id"
                 :strength="strength"
                 :placeholder="placeholder"
                 @input="updatePasswordStrength()"
                 :disableStrength="!withStrength"
    >
        <template v-slot:password-input="props">
            <input
                :class="classes"
                type="password"
                :value="props.value"
                :name="name"
                :id="name"
                :disabled="readOnly"
                :placeholder="placeholder"
                @input="props.updatePassword"
                :autocomplete="autocomplete"
                :required="required"
            />
            <input v-if="readOnly" type="hidden" :name="name" :value="props.value">
        </template>
    </VuePassword>
</template>

<script>
import VuePassword from 'vue-password';
import Input from "../../../../inertia/ts/Jetstream/Elements/Input";

export default {
    name: "PasswordInput",
    components: {Input, VuePassword},
    props: {
        value: String,
        id: String,
        withStrength: Boolean,
        classes: String,
        name: String,
        required: Boolean,
        autocomplete: String,
        readOnly: Boolean,
        placeholder: {
            type: String,
            default: "Enter password"
        }
    },
    data: () => ({
        password: "",
        strength: 0,
    }),
    created() {
        if (this.value) {
            this.password = this.value
            this.updatePasswordStrength()
        }
    },
    computed: {
    },
    methods: {
        updatePasswordStrength() {
            if (!this.withStrength) {
                return
            }
            let url = "/api/password-strength"
            let method = "post"
            let self = this
            axios[method](
                url,
                {pass: this.password},
            ).then(response => {
                if (response.data) {
                    let newStrength = response.data.score
                    if (newStrength >= 0 && newStrength <= 4) {
                        self.strength = newStrength
                    } else {
                        self.strength = 0
                    }
                }
            }).catch(error => {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                    //console.log(this.errors)
                }
            });
        }
    }
}
</script>

<style scoped>
    .form-control.is-invalid {
        background-image: none;
    }
</style>
